import * as actions from 'reducers/purchaseForm';

export function updateSection(purchaseForm) {
  return {
    type: actions.UPDATE_SECTION,
    section: purchaseForm.section
  };
}
